<template>
    <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" :id="id" @input="$emit('input',$event.target.checked)" :checked="value">
        <label class="custom-control-label" :for="id"><b v-html="label"></b></label>
    </div>
</template>

<script>
    import { uuid } from '../../modules/helpers.js';
    export default {
        name: "Checkbox",
        props: ['label', 'value'],
        data: () =>  {
            return {
                id: uuid(),
            }
        },
    }
</script>

<style scoped>

</style>
